import { LocalizedError } from '@/core/i18n';
import { fetchJson } from '@/core/network';
import { fetchWindBlock, WIND_API, type BlockKey, type WindBlock, type WindIndex } from './tiles/format';

/** Errors of the wind API as shown to users; aborts pass through. */
function localized(err: unknown): unknown {
  if (err instanceof DOMException && err.name === 'AbortError') return err;
  return new LocalizedError('forecast:errors.service', {}, { cause: err });
}

/** The latest run of each model the wind API serves (see worker/). */
export async function fetchWindIndex(signal: AbortSignal): Promise<WindIndex> {
  try {
    return await fetchJson<WindIndex>(`${WIND_API}/index.json`, signal);
  } catch (err) {
    throw localized(err);
  }
}

/** One block of wind from the API. */
export async function fetchBlock(key: BlockKey, signal: AbortSignal): Promise<WindBlock> {
  try {
    return await fetchWindBlock(key, signal);
  } catch (err) {
    throw localized(err);
  }
}
